
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Kode MCC', value: 'mcc'},
  { text: 'Kategori MCC', value: 'category_name'},
  { text: 'Jenis Usaha', value: 'mcc_name'},
  { text: 'MDR On Us', value: 'mdr_on_us'},
  { text: 'MDR Off Us', value: 'mdr_off_us'},
  { text: 'Created Date', value: 'created_at'},
  { text: 'Last Updated Date', value: 'updated_at'},
  { text: 'Status', value: 'custom_status',  align: 'center', textAlign: 'text-center'},
  { text: 'Action', value: 'action', width: '100' }
]);

export const dataListMccMdrStatus = [
  { value_number: '1', value: '1', text: 'Active' },
  { value_number: '0', value: '0', text: 'Inactive' },
];

export const dataCategoryMccMdr = [
  { value_number: '1', value: '1', text: 'Reguler' },
  { value_number: '2', value: '2', text: 'Khusus' },
];

export const defaultItem = {
  mcc: '',
  description: '',
  category_id: '',
  mcc_category_name: '',
  mcc_name: '',
  mdr_on_us: '',
  mdr_off_us: '',
  status: '',
};

export const editedItem = {
  mcc: '',
  description: '',
  category_id: '',
  mcc_category_name: '',
  mcc_name: '',
  mdr_on_us: '',
  mdr_off_us: '',
  status: '',
};

export const search = {
  mcc: '',
  description: '',
  category_id: '',
  mcc_name: '',
  mdr_on_us: '',
  mdr_off_us: '',
  status: '',
  created_at: null,
  updated_at: null,
};

